import { useContext } from 'react';
import GithubContext from '../../context/github/GithubContex';
import Loader from '../layout/Loader';
import UserItem from './UserItem';

const UserResults = () => {
	const { users, loading } = useContext(GithubContext);

	if (!loading) {
		return (
			<div className='grid grid-cols-1 gap-8 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2'>
				{users.map((user) => (
					<UserItem key={user.id} user={user} />
				))}
			</div>
		);
	} else {
		return <Loader />;
	}
};

export default UserResults;
